export default "__VITE_PUBLIC_ASSET__a5f25c3f__"